var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgEn(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 7,
    viewBox: "0 0 13 7",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.0011 0H0V7H12.0011V0Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.03514 2.52822L12.0013 0.308126V0H11.7287L7.20557 2.52822H8.03514Z",
    fill: "#BD0034"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M7.84937 4.60999L12.0012 6.93278V6.46664L8.67894 4.60999H7.84937Z",
    fill: "#BD0034"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0.533156L3.55135 2.52808H4.38093L0 0.0670166V0.533156Z",
    fill: "#BD0034"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M4.19526 4.60999L0 6.96044V6.99994H0.758466L5.02483 4.60999H4.19526Z",
    fill: "#BD0034"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M11.1797 0H6.98047V2.35045L11.1797 0Z",
    fill: "#1A237B"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M5.12364 0H0.936279L5.12364 2.35045V0Z",
    fill: "#1A237B"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M12.0013 2.52828V0.924438L9.15308 2.52828H12.0013Z",
    fill: "#1A237B"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M12.0013 6.19802V4.60999H9.15308L12.0013 6.19802Z",
    fill: "#1A237B"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M1.17334 7.00003H5.12368V4.78784L1.17334 7.00003Z",
    fill: "#1A237B"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M6.98047 7.00003H10.9387L6.98047 4.78784V7.00003Z",
    fill: "#1A237B"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M0 4.60999V6.26913L2.9509 4.60999H0Z",
    fill: "#1A237B"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M0 2.52808H2.9509L0 0.86499V2.52808Z",
    fill: "#1A237B"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M5.49492 0V2.94695H0V4.19526H5.49492V7H6.60892V4.19526H12.0011V2.94695H6.60892V0H5.49492Z",
    fill: "#BD0034"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEn);
export default __webpack_public_path__ + "static/media/en.a7fd542f7556fd4d4bb54d64bd008d11.svg";
export { ForwardRef as ReactComponent };